import { Component, OnInit, ViewChild } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Observable, map, shareReplay } from "rxjs";
import { MatSidenav } from "@angular/material/sidenav";
import { UserService } from "../../../../shared/services/user.service";
import { UserDto } from "../../../../common/dtos/user/user.dto";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: [
    "./sidebar.component.scss"
  ]
})
export class SidebarComponent implements OnInit {

    @ViewChild(MatSidenav) sidenav!: MatSidenav;
    // username!: string | undefined;
    user!: UserDto | undefined;
    isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
      .pipe(
        map((result) => result.matches),
        shareReplay()
      );

    menuItems = [
      { title: "observationcard.title", icon: "credit_card", routerLink: "observations" },
      { title: "projects.title", icon: "apps", routerLink: "projects" }
    ];

    menuItemsCharts = [
      { title: "observationcard.title", icon: "credit_card", routerLink: "observations" },
      { title: "projects.title", icon: "apps", routerLink: "projects" },
      { title: "Charts", icon: "timeline", routerLink: "charts" }
    ];

    menuItemsAdmin = [
      { title: "observationcard.title", icon: "credit_card", routerLink: "observations" },
      { title: "users.title", icon: "group", routerLink: "users" },
      { title: "projects.title", icon: "apps", routerLink: "projects" },
      { title: "references.title", icon: "list", routerLink: "references" },
      { title: "Charts", icon: "timeline", routerLink: "charts" }
    ];

    constructor(
        private breakpointObserver: BreakpointObserver,
        private userService: UserService
    ) {
    }

    async ngOnInit(): Promise<void> {
      await this.userService.getUserDto().subscribe((name) => {
        this.user = name!;
      });
    }

    getMenuItemsBasedOnRole() {
      if (this.user?.role === "ADMIN") {
        return this.menuItemsAdmin;
      } else if (this.user?.role === "USER_CHARTS") {
        return this.menuItemsCharts;
      } else {
        return this.menuItems;
      }
    }
}
